import { Box, IconButton, Paper, Typography } from '@mui/material';
import { format } from 'date-fns';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Util from '../../../../../../misc/util';
import { ArrowLeftIcon, ArrowRightIcon } from '../../../../../icons';
import { DatePicker, DatePickerProps } from '../../../../atomic';
import { Button } from '../../../../atomic/button';

interface BoxProps {
  date?: Date;
  onChange: (date?: Date) => void;
  title?: string;
  resetButton?: boolean;
}

type Props = BoxProps &
  Pick<DatePickerProps, 'minDate' | 'maxDate' | 'disableFuture' | 'disablePast' | 'openTo'>;

export const DatePickerBox: FC<Props> = ({
  date,
  onChange,
  title,
  minDate,
  maxDate,
  disableFuture,
  disablePast,
  openTo,
  resetButton
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState(false);

  const handleNextClick = () => {
    onChange(Util.getNextMonth(date || new Date()));
  };

  const handlePrevClick = () => {
    onChange(Util.getPrevMonth(date || new Date()));
  };

  return (
    <Paper
      sx={{
        padding: '24px'
      }}
    >
      <Box display="flex">
        <Typography variant="h3" marginBottom="16px" flex={1}>
          {title ?? t('common:PERIOD')}
        </Typography>
        <IconButton onClick={() => handlePrevClick()} sx={{ marginBottom: '1rem', padding: 0 }}>
          <ArrowLeftIcon />
        </IconButton>
        <IconButton onClick={() => handleNextClick()} sx={{ marginBottom: '1rem', padding: 0 }}>
          <ArrowRightIcon />
        </IconButton>
      </Box>
      <DatePicker
        variant="month"
        initialValue={date ? format(date, 'yyyy-MM-dd') : null}
        onChange={(date) => {
          setError(false);
          onChange(date ? new Date(date) : undefined);
        }}
        onChangeInvalidDate={() => setError(true)}
        helperText={t('form:INVALID_DATE')}
        error={error}
        minDate={minDate}
        maxDate={maxDate}
        disableFuture={disableFuture}
        disablePast={disablePast}
        openTo={openTo}
      />
      {resetButton && (
        <Button
          onClick={() => {
            onChange(undefined);
          }}
          disabled={!date}
          className="mt-4 w-full"
        >
          {t('common:RESET')}
        </Button>
      )}
    </Paper>
  );
};
